   // individual hex calculations
   const createHexagon = (svg,x,y,yProfiles,r,state,displayPercent)=> {
    let svgNS  = svg.namespaceURI, // svgNS for creating svg elements
            group	 = document.createElementNS(svgNS, "g"),
            hex 	 = document.createElementNS(svgNS, "polygon"),
            abbr 	 = document.createElementNS(svgNS, "text"),
            profile  = document.createElementNS(svgNS, "text"),
            percent = displayPercent && document.createElementNS(svgNS, "text"),
            pi_six = Math.PI/6,
            cos_six = Math.cos(pi_six),
            sin_six = Math.sin(pi_six);
    displayPercent && group.setAttribute("tabindex", 0);
    displayPercent && group.setAttribute("id", state.xAxis);
    displayPercent && group.setAttribute("aria-label",`${state.xAxis}: ${state.yAxis}%` );

    // hexagon polygon points
    let hex_points = [
      [x, y - r].join(","),
      [x + cos_six * r, y - sin_six * r].join(","),
      [x + cos_six * r, y + sin_six * r].join(","),
      [x, y + r].join(","),
      [x - cos_six * r, y + sin_six * r].join(","),
      [x - cos_six * r, y - sin_six * r].join(",")
    ]

    hex.setAttribute("points", hex_points.join(" "));
    hex.style.transformOrigin = x + 'px ' + y + 'px';

    abbr.setAttribute("class", "state-abbr");
    abbr.setAttribute("x", x);
    abbr.setAttribute("y", y);
    abbr.textContent = state.abbr || state.xAxis;

    profile.setAttribute("class", "state-profile");
    profile.setAttribute("x", x);
    profile.setAttribute("y", yProfiles);
    if(state.profiles){
      profile.textContent = state.profiles
    } else {
      if(parseFloat(state.yAxis) < 11 ){
        profile.textContent = 1
      } else if(parseFloat(state.yAxis) > 10 && parseFloat(state.yAxis) < 21){
        profile.textContent = 2
      } else if(parseFloat(state.yAxis) > 20 && parseFloat(state.yAxis) < 31){
        profile.textContent = 3
      } else if(parseFloat(state.yAxis) > 30 && parseFloat(state.yAxis) < 41){
        profile.textContent = 4
      } else if(parseFloat(state.yAxis) > 40 && parseFloat(state.yAxis) < 51){
        profile.textContent = 5
      } else if(parseFloat(state.yAxis) > 50 && parseFloat(state.yAxis) < 61){
        profile.textContent = 6
      } else {
        profile.textContent = 0
      } 
    }

    // name.textContent = state.name;

    group.appendChild(hex);
    group.appendChild(abbr);
    group.appendChild(profile);
    
    if(displayPercent){
      percent.setAttribute("class", "state-name");
      percent.setAttribute("x", x);
      percent.setAttribute("y", y);
      percent.textContent = state.xAxis + ": " + state.yAxis + "%";
      group.append(percent)
    }
    return group;
};
export default createHexagon;